import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  BlockAndUnblockDepositBonusClient,
  DepositBonusClient,
  UpdateDepositBonusClient,
  UserPromoCode,
  UserPromoCodeItem,
} from './types'
import { $params } from '../../../../features/router'

export const setDepositBonusClient = createEvent<DepositBonusClient>()

export const depositBonusClientMounted = createEvent()

export const updateDepositBonusClientMounted =
  createEvent<UpdateDepositBonusClient>()

export const banAndUnbanDepositBonusClientMounted =
  createEvent<BlockAndUnblockDepositBonusClient>()

export const getDepositBonusClient = fx<void, DepositBonusClient>({
  method: 'GET',
  url: `/deposit_bonus/user/{id}`,
})

export const updateDepositBonusClient = fx<
  void,
  Omit<UpdateDepositBonusClient, 'id'>
>({
  method: 'PUT',
  url: `/deposit_bonus/user/{id}`,
})

export const banAndUnbanDepositBonusClient = fx<
  void,
  Omit<BlockAndUnblockDepositBonusClient, 'id'>
>({
  method: 'PUT',
  url: `/deposit_bonus/user/{id}`,
})

export const $depositBonusClient = restore(setDepositBonusClient, {
  id: 0,
  country: '',
  bonusPercent: 0,
  promoCodeId: 0,
  welcomeBonusExpiresAt: '',
  bannedAt: '',
  banReason: '',
  personalBonusComment: '',
  personalBonusActivatedAt: '',
  personalBonusEnabledAt: '',
  isBanned: false,
  userPromoCode: {
    humanUpdatedAt: '',
    promoCode: {
      humanUpdatedAt: '',
      code: '',
      bonusPercent: 0,
    },
  },
  humanUpdatedAt: '',
})

sample({
  clock: depositBonusClientMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.clientID
    }

    return {
      url: `/deposit_bonus/user/${id}`,
      query: {
        populate: JSON.stringify(['User', 'User.userPromoCode']),
      },
    }
  },
  target: getDepositBonusClient,
})

sample({
  // @ts-ignore
  clock: updateDepositBonusClientMounted,
  fn: (data) => {
    const { id, bonusPercent, personalBonusComment } = data

    return {
      url: `/deposit_bonus/user/${id}`,
      body: {
        bonusPercent,
        personalBonusComment,
      },
    }
  },
  target: updateDepositBonusClient,
})

sample({
  // @ts-ignore
  clock: banAndUnbanDepositBonusClientMounted,
  fn: (data) => {
    const { id, isBanned, banReason } = data

    return {
      url: `/deposit_bonus/user/${id}`,
      body: {
        isBanned,
        banReason,
      },
    }
  },
  target: banAndUnbanDepositBonusClient,
})

sample({
  clock: [getDepositBonusClient.doneData],
  fn: (doneData) => doneData.body,
  target: [setDepositBonusClient],
})
